import { Badge } from '@/components/ui/badge';
import { RESUME_CONFIGS } from '@/constants/scenarios';
import { ScenarioType } from '@/types/scenario';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleProp, ViewStyle } from 'react-native';
import { Tooltip } from './ui/tooltip';
import { View } from './ui/tw-wrappers';

interface ScenarioBadgeProps {
  type: ScenarioType;
  style?: StyleProp<ViewStyle>;
}

export const ScenarioBadge: React.FC<ScenarioBadgeProps> = ({ type, style }) => {
  const { t } = useTranslation();
  const config = RESUME_CONFIGS[type];

  return (
    <View className='flex-row gap-2'>
      <Tooltip
        content={t('scenarios.resultsBadge.risk')}
      >
        <Badge
          label={t(`scenarios.types.${type}.resume.risk`)}
          color={config.badge.risk.color}
          iconName={config.badge.risk.iconName}
          style={style}
        />
      </Tooltip>
      <Tooltip
        content={t('scenarios.resultsBadge.competitiveness')}
      >
        <Badge
          label={t(`scenarios.types.${type}.resume.competitiveness`)}
          color={config.badge.competitiveness.color}
          iconName={config.badge.competitiveness.iconName}
          style={style}
        />
      </Tooltip>
    </View>
  );
};
